import * as signals from "@/signals";
import { BookmarkInfo } from "@/types";
import {
	getTranslatorUrl,
	openNote,
	openPopup,
	openWebPage,
	toggleSecondaryScreen,
	updateSettings,
} from "@/utils";
import { t } from "i18next";

export function getPresetShortcutDetails(): Record<string, BookmarkInfo> {
	return {
		airportal: {
			color: "linear-gradient(135deg, #aed2ff, #0055c0)",
			icon: "\ue6b9",
			id: "airportal",
			itemType: "preset",
			title: t("airportal"),
			url: "https://www.airportal.cn/",
		},
		aiTools: {
			color: "linear-gradient(135deg, #dce35b, #448000)",
			hasPopup: true,
			icon: "\ue65e",
			id: "aiTools",
			itemType: "preset",
			onClick: (): void => {
				openPopup("aiTools");
			},
			title: t("aiTools"),
			url: null,
		},
		allShortcuts: {
			color: "linear-gradient(135deg, #54aee5, #936ad1)",
			icon: "\ue68f",
			id: "allShortcuts",
			itemType: "preset",
			onClick: (): void => {
				void toggleSecondaryScreen();
			},
			title: t("allShortcuts"),
			url: null,
		},
		bilibili: {
			color: "linear-gradient(135deg, #ffa2bf, #eb4772)",
			icon: "\ue948",
			id: "bilibili",
			itemType: "preset",
			title: "bilibili",
			url: "https://www.bilibili.com/",
		},
		cloudMusic: {
			color: "linear-gradient(135deg, #ffa3aa, #f24452)",
			icon: "\ue804",
			id: "cloudMusic",
			itemType: "preset",
			title: t("cloudMusic"),
			url: "https://music.163.com/",
		},
		darkMode: {
			color: signals.isDark.value
				? "linear-gradient(135deg, #ffeca9, #ebc84f)"
				: "linear-gradient(135deg, #f7ce46, #d56829)",
			icon: signals.isDark.value ? "\ueecf" : "\ue939",
			id: "darkMode",
			itemType: "preset",
			onClick: (): void => {
				void updateSettings({
					theme: signals.isDark.value ? "light" : "dark",
				});
			},
			title: t("darkThemeTitle"),
			url: null,
		},
		image: {
			color: "linear-gradient(135deg, #ffad8d, #f3525c)",
			icon: "\ue7ac",
			id: "image",
			itemType: "preset",
			title: t("images"),
			url: "https://image.baidu.com/",
		},
		notes: {
			color: "linear-gradient(135deg, #ffd976, #dd8900)",
			hasPopup: true,
			icon: "\ue80f",
			id: "notes",
			itemType: "preset",
			onClick: (): void => {
				openNote();
			},
			title: t("notes"),
			url: null,
		},
		qqMail: {
			color: "linear-gradient(135deg, #ffb597, #d75d2b)",
			icon: "\ue712",
			id: "qqMail",
			itemType: "preset",
			title: t("qqMail"),
			url: "https://mail.qq.com/",
		},
		translate: {
			color: "linear-gradient(135deg, #7cd6ff, #1a87b2)",
			icon: "\ue8f6",
			id: "translate",
			itemType: "preset",
			onClick: (): void => {
				const translatorUrl = getTranslatorUrl(
					signals.selectedSearchEngine.value.id,
				);
				openWebPage(translatorUrl);
			},
			title: t("translate"),
			url: null,
		},
		wallpaper: {
			color: "linear-gradient(135deg, #54aee5, #936ad1)",
			hasPopup: true,
			icon: "\ue74c",
			id: "wallpaper",
			itemType: "preset",
			onClick: (): void => {
				openPopup("wallpaper");
			},
			title: t("wallpaper"),
			url: null,
		},
	};
}
